import { Container, Typography, Box, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import WorkflowBuilder from '../components/WorkflowBuilder';

const WorkflowEditorPage = () => {
  const { id } = useParams<{ id: string }>();
  const isEditMode = !!id;

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Breadcrumbs sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/settings/workflows" color="inherit">
            Workflows
          </Link>
          <Typography color="textPrimary">
            {isEditMode ? 'Edit Workflow' : 'Create Workflow'}
          </Typography>
        </Breadcrumbs>
        
        <Typography variant="h4" component="h1" gutterBottom>
          {isEditMode ? 'Edit Workflow' : 'Create Workflow'}
        </Typography>
        
        <WorkflowBuilder />
      </Box>
    </Container>
  );
};

export default WorkflowEditorPage; 